import { render, staticRenderFns } from "./ProjectOnHoldDeliverableTypeIcon.vue?vue&type=template&id=180a9880&"
import script from "./ProjectOnHoldDeliverableTypeIcon.vue?vue&type=script&lang=js&"
export * from "./ProjectOnHoldDeliverableTypeIcon.vue?vue&type=script&lang=js&"
import style0 from "./ProjectOnHoldDeliverableTypeIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports